<template>
    <p class="mb-2">
        <span class="font-bold mr-2">{{ label }}:</span>

        <slot></slot>
    </p>
</template>

<script>
export default {
    props: {
        label: String
    }
};
</script>

<style scoped>

</style>
